import React from "react";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>

        <p className="legal-effective">
          <strong>Effective Date:</strong> July 31, 2026
        </p>

        <p>
          This Privacy Policy explains how <strong>NN AI Solutions</strong>{" "}
          collects, uses, stores and protects information when you use{" "}
          <strong>NN FIT</strong>, our gym and fitness management platform.
        </p>

        <section>
          <h2>1. Information We Collect</h2>

          <p>
            Depending on how NN FIT is used, we may collect information
            including:
          </p>

          <ul>
            <li>Gym name and owner name.</li>
            <li>Phone number and email address.</li>
            <li>Account and authentication information.</li>
            <li>Gym member information entered by gym administrators.</li>
            <li>Membership and attendance information.</li>
            <li>Trainer and workout information.</li>
            <li>Payment and subscription information.</li>
            <li>Member photographs where uploaded by the gym.</li>
            <li>
              Technical and usage information required to operate the service.
            </li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Information</h2>

          <p>Information may be used to:</p>

          <ul>
            <li>Create and manage gym accounts.</li>
            <li>Provide NN FIT features and services.</li>
            <li>Manage members, memberships and attendance.</li>
            <li>Process and manage subscriptions.</li>
            <li>Provide customer support.</li>
            <li>Maintain platform security.</li>
            <li>Detect and prevent fraud or misuse.</li>
            <li>Improve platform performance and functionality.</li>
            <li>Send important service-related communications.</li>
          </ul>
        </section>

        <section>
          <h2>3. Gym Member Information</h2>

          <p>
            Gym administrators may enter member information into NN FIT for the
            purpose of managing their gym operations.
          </p>

          <p>
            The gym is responsible for ensuring that it has an appropriate legal
            basis, authorization or consent where required to collect and
            process member information.
          </p>
        </section>

        <section>
          <h2>4. Photographs</h2>

          <p>
            NN FIT may allow gyms to upload member photographs for
            identification and gym management purposes.
          </p>

          <p>
            Gym administrators are responsible for obtaining appropriate
            permission or consent where required before uploading photographs of
            their members.
          </p>
        </section>

        <section>
          <h2>5. Payment Information</h2>

          <p>
            Subscription payments may be processed by third-party payment
            providers.
          </p>

          <p>
            NN AI Solutions does not intend to store complete payment card
            credentials such as full card numbers when those details are handled
            directly by the applicable payment provider.
          </p>
        </section>

        <section>
          <h2>6. Authentication and Account Security</h2>

          <p>
            NN FIT may use authentication services to create and secure user
            accounts.
          </p>

          <p>
            Users are responsible for maintaining the confidentiality of their
            passwords and account credentials.
          </p>
        </section>

        <section>
          <h2>7. Data Storage</h2>

          <p>
            Information may be stored using third-party cloud infrastructure and
            storage services used to operate NN FIT.
          </p>

          <p>
            We take commercially reasonable measures to protect stored
            information against unauthorized access, alteration or disclosure.
          </p>
        </section>

        <section>
          <h2>8. Data Sharing</h2>

          <p>
            We do not intend to sell users' personal information as a business
            practice.
          </p>

          <p>
            Information may be shared with service providers where necessary to
            operate NN FIT, such as cloud hosting, storage, authentication,
            payment processing and other infrastructure providers.
          </p>

          <p>
            Information may also be disclosed where required by applicable law,
            legal process or to protect the security and rights of NN FIT, NN AI
            Solutions or its users.
          </p>
        </section>

        <section>
          <h2>9. Data Ownership</h2>

          <p>
            Subject to applicable law and third-party rights, gyms retain
            ownership of the business and member information they submit to NN
            FIT.
          </p>

          <p>
            NN AI Solutions processes such information to provide the requested
            software services.
          </p>
        </section>

        <section>
          <h2>10. Data Security</h2>

          <p>
            We implement commercially reasonable technical and organizational
            measures designed to protect information.
          </p>

          <p>
            However, no online service, network or storage system can be
            guaranteed to be completely secure.
          </p>
        </section>

        <section>
          <h2>11. Data Retention</h2>

          <p>
            Information may be retained for as long as reasonably necessary to
            provide services, maintain business records, comply with legal
            obligations, resolve disputes and enforce agreements.
          </p>
        </section>

        <section>
          <h2>12. Account Deletion</h2>

          <p>
            Users may contact NN FIT support regarding account closure or
            deletion requests.
          </p>

          <p>
            Certain information may need to be retained where required for
            legal, security, accounting or legitimate business purposes.
          </p>
        </section>

        <section>
          <h2>13. Cookies and Technical Information</h2>

          <p>
            NN FIT may use cookies, local storage and similar technologies where
            necessary for authentication, security, preferences and platform
            functionality.
          </p>

          <p>
            Technical information such as browser type, device information, IP
            address and service activity may be collected where necessary to
            operate and secure the platform.
          </p>
        </section>

        <section>
          <h2>14. Third-Party Services</h2>

          <p>
            NN FIT may integrate with third-party services. Those providers may
            process information according to their own privacy policies and
            terms.
          </p>
        </section>

        <section>
          <h2>15. Children's Privacy</h2>

          <p>
            NN FIT is designed for gym and business administrators and is not
            intended for individuals who are below the applicable minimum age
            required to independently use the service.
          </p>

          <p>
            Gym administrators remain responsible for complying with applicable
            requirements when managing information relating to younger gym
            members.
          </p>
        </section>

        <section>
          <h2>16. Your Responsibilities</h2>

          <p>
            Users are responsible for ensuring that the information they provide
            to NN FIT is accurate and that they have the necessary authority or
            permissions to provide personal information belonging to their
            members, staff or other individuals.
          </p>
        </section>

        <section>
          <h2>17. Changes to This Privacy Policy</h2>

          <p>
            This Privacy Policy may be updated periodically to reflect changes
            to NN FIT, applicable requirements or our data practices.
          </p>

          <p>
            Updated versions will be published on this page with a revised
            effective date.
          </p>
        </section>

        <section>
          <h2>18. Contact Us</h2>

          <p>
            <strong>NN AI Solutions</strong>
            <br />
            Nizamabad, Telangana, India
            <br />
            Phone: 8688663447
            <br />
            Email: info@nnaisolution.com, info@nnfit.in
            <br />
            Website: nnfit.in, nnaisolution.com
          </p>
        </section>
      </div>
    </div>
  );
}
